var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-adv"},[_c('div',{staticClass:"content"},[_c('a',{attrs:{"href":_vm.advConfig.url}},[_c('img',{attrs:{"src":_vm._f("urlFilter")(_vm.advConfig.img),"alt":""}})]),_c('span',{staticClass:"close",on:{"click":function($event){_vm.$parent.isWelcomeAd = false}}},[_vm._v(" "+_vm._s(_vm.count)+"s"+_vm._s(_vm.$t('skip')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }